import { useQuery } from '@apollo/client';
import { useMemo } from 'react'
import { investorAccountType } from 'src/types/investor-account-types';
import { balanceQuery } from 'src/types/balance-types';
import { BALANCE } from 'src/graphql/queries/balance';

const useProfitSharingInfos = (selectedInvestorAccount:investorAccountType | null | undefined) => {

    const { data: Balance, loading: BalanceLoading } = useQuery<balanceQuery>(BALANCE, {
            variables: { investorAccountID : selectedInvestorAccount?.investorAccountID || "" },
            skip: !selectedInvestorAccount?.investorAccountID,
        }
    );

    const balance = useMemo(() => {
        if (Balance?.balance?.__typename === "BalanceOutput") return Balance.balance;
        return undefined;
    }, [Balance]);

    const modelInfo = selectedInvestorAccount?.subscription?.modelInfo;
    const isProfitSharing = useMemo(() => {
        if (!modelInfo) return false;
        if (!balance) return false;
        const profit = modelInfo.pctProfitSharing * balance?.subscriptionReturn;
        return profit > 0;
    }, [modelInfo, Balance])

    return isProfitSharing
}

export default useProfitSharingInfos